import { createStyles } from '../../../../../styles/helpers'

const useStyles = createStyles({
  confirmButtonWrapper: {
    width: ['unset', '!important']
  }
})

export default useStyles
